import { faBoxArchive, faBoxesStacked, faEdit, faEye, faGear, faPlus, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import prodotti_fetch from '../fetch/prodotti_fetch';
import SelezionaMagazzino from '../Magazzino/SelezionaMagazzino';
import ConfermaEliminazione from '../riutilizabili/ConfermaEliminazione';
import InputForm from '../riutilizabili/forms/InputForm';
import SelectForm from '../riutilizabili/forms/SelectForm';
import InfoModal from '../riutilizabili/InfoModal';
import PulsantiFiltra from '../riutilizabili/PulsantiFiltra'; 
import QuestionModal from '../riutilizabili/QuestionModal';
import SelectLivello from '../riutilizabili/SelectLivello';
import Tabella from '../riutilizabili/Tabella';
import AssegnaMg from './AssegnaMg';
import CampiProdotti from './CampiProdotti';
import PaginazioneTitoloPulsanteCrea from '../riutilizabili/PaginazioneTitoloPulsanteCrea';
import UploadFile from '../riutilizabili/UploadFile';
import ViewImgPreUpload from '../riutilizabili/ViewImgPreUpload';
import caricaFile_fetch from '../fetch/caricaFile_fetch';
import ImgsProd from './ImgsProd.js';
import ImgTabella from './ImgTabella.js';
import TabellaPaginazione from '../riutilizabili/TabellaPaginazione.js';
import UploadDocProd from './UploadDocProd.js';
import ViewDocProd from '../riutilizabili/ViewDocProd.js';
import ViewProdDisp from './ViewProdDisp.js';
import ViewProdPopUp from './ViewProdPopUp.js';
import { set } from 'date-fns';
import InventarioPrimaImp from './InventarioPrimaImp.js';
import SwitchOr from '../riutilizabili/forms/SwitchOr.js';
 


export default function ReadProdotti() {
    const navigate = useNavigate();

    const [error, setError] = useState({});
    const [inputs, setInputs] = useState({});
    const [datiProd, setDatiProd] = useState([]);
    const [datiCrea , setDatiCrea] = useState({automaticReorder : 1 , ricarico : 15});
    const [datiModifica , setDatiModifica] = useState({});
    const [datiAssegnaMagazzino , setDatiAssegnaMagazzino] = useState({});
    const [datiView , setDatiView] = useState({});
    const [imgProd , setImgProd] = useState([]);
    const [imgProdMod , setImgProdMod] = useState([]);
    const [viewCrea , setViewCrea] = useState(false);
    const [viewModifica , setViewModifica] = useState(false);
    const [viewAssegnaMagazzino , setViewAssegnaMagazzino] = useState(false);
    const [viewView , setViewView ] = useState(false);
    const [viewEliminaProd, setViewEliminaProd] = useState(false);

    const [docProd , setDocProd] = useState([])

    const [pageTot , setPageTot] = useState(0);
    const [pageSize , setPageSize] = useState(20);
    const [page , setPage] = useState(1);
    const [azzeraVar , setAzzeraVar] = useState(0)
    const [fu , setFu] = useState(0)
    const [inputsFiltra , setInputsFiltra] = useState({})
    
    const [qtPrimaImp , setQtPrimaImp] = useState(false)
    const [inventarioView , setInventarioView] = useState(false)
    const [qtPrimaImpError , setQtPrimaImpError] = useState({})



    useEffect( ()=>{
        readProdotti()
    },[])

    const oncloseInventario = (stato) => {
        setInventarioView(stato)
    }

    const readProdotti = async () => {
        const response = await prodotti_fetch.get({pageSize , page ,stato : 1})
        let tmp = [...response.data.data]
        for (let index = 0; index < tmp.length; index++) {
            const element = tmp[index];
            element.nomeUnitaMisura = element?.infoUnitaMisura?.nome
        }
        setDatiProd(tmp)
        setPageTot(response.data.pageTot)
        setFu(fu+1)
        setInputs({})
        setError({})
    }

    const columns = [
         {
                label: 'riferimento interno',
                nome: 'rifInterno',
                altCol : (item)=> {
                    return(
                        <div style={{width: '15rem'}} className='align-middle fs-6 text-start' >
                          {item.rifInterno}
                        </div>
                    )
                }
              },
              {
                label: 'Immagine',
                nome: 'img',
                altCol : (item)=> {
                    return(
                        <div style={{width: '10rem'}} className='m-auto' >
                          <ImgTabella prodId={item.id} />
                        </div>
                    )
                }
              },
               {
                      label: 'Descrizione breve',
                      nome: 'descrizioneBreve',
                      altCol: (item)=> {
                          return(
                              <div className='align-middle' >
                                  <ViewProdPopUp
                                      icona={item?.descrizioneBreve}
                                      prodAnId={item?.id}
                                      classiButton='d-flex'
                                  />
                              </div>
                          )
                          }
                      },
              {
                label: 'Categoria',
                nome: 'infoCategoria.nome',
                altCol: (item)=> {
                    return(
                        <div style={{width: '10rem'}} className='align-middle fs-6' >
                          {item?.infoCategoria?.nome +(!!item?.infoSottoCategoria ? ' => ' +item?.infoSottoCategoria?.nome : ' ')}
                        </div>
                    )
                }
              },
        ]
    const handleChangeFiltra = (name , value) => {
        //console.log(name , value);
        setInputs(values => ({ ...values, [name]: value }))
        //filtra({[name]: value})
    }
    
    const handleChangeModifica = (name , value) => {
        //console.log(name , value);
        setDatiModifica(values => ({ ...values, [name]: value }))
    }
    
    const handleChangeAssegnaPosizione = (name , value) => {
        //console.log(name , value);
        setDatiAssegnaMagazzino(values => ({ ...values, [name]: value }))
    }
    
    const handleChangeCrea = (name , value) => {
        //console.log(name , value);
        setDatiCrea(values => ({ ...values, [name]: value }))
    }

    const filtra = async (param) => {
        await prodotti_fetch.get({pageSize , page ,...inputs ,  stato : 1 , ...param})
        .then(response => {
            //console.log(response.data , ' response.data');
            setDatiProd(response.data.data)
            setPageTot(response.data.pageTot)
            setFu(fu+1)
        })
        .catch(error => {
            if (error?.response?.status === 406) {
                navigate("/login");
            }
        })
    }

    const modificaProdotto = async (stato) => {
        if (stato) {
            await prodotti_fetch.update(imgProd ,datiModifica , docProd)
            .then(response => {
                readProdotti()
                setViewModifica(false)
                setDatiModifica({})
            })
            .catch(error=> {
                if (error?.response?.status === 406) {
                    navigate("/login");;
                }else {
                    setError(error?.response?.data)
                }
                //console.log(error?.response?.data , ' error');
            })
        }else {
            setViewModifica(false)
        }
    }

    const creaProdotto = async (stato) => {
        if (stato) {
            //console.log(datiCrea , 'formdata 0');
            await prodotti_fetch.create({imgProd , datiCrea ,docProd})
            .then(response => {
                readProdotti()
                setViewCrea(false)
                setDatiCrea({})
                setImgProd([])
            })
            .catch(error=> {
                if (error?.response?.status === 406) {
                    navigate("/login");;
                }else {
                    setError(error?.response?.data)
                }
                //console.log(error?.response?.data , ' error');
            })
        }else {
            setViewCrea(false)
        }
    }
    
    const viewPr = async (id) => {
        const an = await prodotti_fetch.get({id : id})
        
        const array = an.data[0];
        //console.log(array , 'array');
        let newArray = {}
        const datiPrendere = [
            'nome', 
            'descrizione', 
            'descrizioneBreve', 
            'infoCategoria' ,
            'infoSottoCategoria' ,
            'produttore' ,
            'infoFornitore' ,
            'codBarre' ,
            'prezzoVendita' ,
            'costo' ,
            'rifInterno' ,
            'note' ,
            'asin' ,
            'qtMin' ,
            'automaticReorder' ,
            'posizioneMg' ,
            'codForitore' ,
        ]
        for (let index = 0; index < Object.keys(array).length; index++) {
            const element = Object.keys(array)[index];
            //console.log(element , ' element');
            if (datiPrendere.includes(element)) {
                if (element === 'infoCategoria') {
                    newArray['Categoria'] = array[element].nome
                }else if (element === 'infoSottoCategoria') {
                    newArray['SottoCategoria'] = array[element]?.nome
                }else if (element === 'infoFornitore') {
                    newArray['Fornitore'] = array[element]?.viewName
                }else if (element === 'descrizione') {
                    newArray['Descrizione'] = array[element]
                }else if (element === 'descrizioneBreve') {
                    newArray['Descrizione breve'] = array[element]
                }else if (element === 'codForitore') {
                    newArray['Codice foritore'] = array[element]
                }else if (element === 'codBarre') {
                    newArray['Codice a barre'] = array[element]
                }else if (element === 'prezzoVendita') {
                    newArray['Prezzo di vendita'] = array[element]
                }else if (element === 'rifInterno') {
                    newArray['Riferimento interno'] = array[element]
                }else if (element === 'qtMin') {
                    newArray['Quantita minima'] = array[element]
                }else if (element === 'produttore') {
                    newArray['Produttore'] = array[element]
                }else if (element === 'nome') {
                    newArray['Nome'] = array[element]
                }else if (element === 'automaticReorder') {
                    newArray['Riordino automatico'] = array[element] ? 'si' : 'no'
                }else if (element === 'posizioneMg') {
                    // newArray['Posizione prodotti in magazzino'] = 
                    // <ul>
                    //     {array[element].map(item =>{
                    //         return(
                    //             <li>
                    //             il prodotto con codice {item.codiceProd}  è nel magazzino
                    //             {' "'+ item.infoMagazzino.nome}" in posizione {" "+item.livello1 && item.livello1}
                    //             {item.livello2 && item.livello2}
                    //             {item.livello3 && item.livello3}
                    //             {item.livello4 && item.livello4}
                    //             {item.livello5 && item.livello5}
                    //             {item.livello6 && item.livello6}
                    //             </li>
                    //         )
                    //     } )}

                    // </ul>
                }else {
                    if (!datiPrendere.includes(element)) {
                        newArray[element] = array[element]
                        
                    }
                }
            }
        }

       //console.log(newArray , ' newArray');
        setDatiView(newArray)
        setViewView(id)
    }

    const modificaPr = async (id) => {
        const img = await caricaFile_fetch.visualizzaFotoProd(id)
       //console.log(img.data ,' imgimg');
        
        setImgProdMod(img.data)
        await prodotti_fetch.get({id : id})
        .then(an => {
            let tmp = {...an.data[0]}
           //console.log(tmp , ' tmp');
            
            tmp.nomeUnitaMisura = tmp?.infoUnitaMisura?.nome
            tmp.categoria_nome = tmp?.infoCategoria?.nome
            if (tmp?.infoSottoCategoria) {
                tmp.sottoCategoria_nome = tmp?.infoSottoCategoria?.nome
            }
            if (tmp?.infoFornitore) {
                tmp.fornitore_nome = tmp?.infoFornitore?.viewName
            }
            setDatiModifica(tmp)
            setViewModifica(true)
        })
        .catch(error => {
            if (error?.response?.status === 406) {
                navigate("/login");;
            }else{
                setError(error?.response?.data)
            }
        })
    }

    const eliminaProd = async (stato) => {
        console.log(stato , ' stato');
        
        if (stato) {
            console.log('entrp');
            
            try {
                await prodotti_fetch.update([] ,{
                    id: viewEliminaProd.id ,
                    stato : '0'
                })
                
                await filtra();
            } catch (error) {
                console.log('entrp2' , error);
                if (error?.response?.status === 406) {
                    navigate("/login");;
                }else{
                    setError(error?.response?.data)
                }
            }
            // await prodotti_fetch.update([] ,{
            //     id: viewEliminaProd.id ,
            //     stato : '0'
            // })
            // .then(response => {
            //     //console.log(response.data);
            //     filtra();
            // })
            // .catch(error => {
            //     if (error?.response?.status === 406) {
            //         navigate("/login");;
            //     }else{
            //         setError(error?.response?.data)
            //     }
            // })
            
        }
        setViewEliminaProd(false)
    }

    const readQtPrimaImp = async (id , nomeProd) => {
        try {
            const prod = await prodotti_fetch.readQtProdottoId({prodottoId : id})
            setQtPrimaImp({...prod.data , nomeProd , dataCreate : new Date()})
            setQtPrimaImpError({})
        } catch (error) {
            setQtPrimaImp({ quantita:null , nomeProd})
            setQtPrimaImpError(error?.response?.data)
            if (error?.response?.status === 406) {
                navigate("/login");;
            }
        }
    }
    
    const Pulsanti = ({element}) => {
       //console.log(element , ' element');
        
        return(
            <td className='d-flex' style={{height: '5rem'}} >
                <button className='btn  py-0 my-0 button_fix' >
                    <FontAwesomeIcon className=' py-0 my-0 text_bluDue' icon={faEye} onClick={()=>viewPr(element.id)} />
                </button>

                <button className='btn  py-0 my-0 button_fix' >
                    <FontAwesomeIcon className=' py-0 my-0 text_bluDue' icon={faEdit} onClick={()=>modificaPr(element.id)} />
                </button>

                <button className='btn  py-0 my-0 button_fix' >
                    <FontAwesomeIcon className=' py-0 my-0 text_bluDue' icon={faGear} onClick={()=>{setQtPrimaImp({id: element.id , nomeProd :element.descrizioneBreve});oncloseInventario(true)}} />
                </button>

                {/* <button className='btn  py-0 my-0 button_fix' >
                    <FontAwesomeIcon className=' py-0 my-0 text_bluDue' icon={faBoxesStacked} onClick={()=>viewAssegnaMg(element.id , element.nome)} />
                </button> */}

                {/* <button className='btn  py-0 my-0 button_fix' >
                    <FontAwesomeIcon className=' py-0 my-0 text_bluDue' icon={faTrash} onClick={()=>setViewEliminaProd(element)} />
                </button> */}
                <button title='Seriali' className='btn py-0 my-0 button_fix'  onClick={() => navigate(`/ViewSeriali?rifInterno=${element.rifInterno}`)}>
                    S
                </button>
                <ViewProdDisp 
                    iconButton={<FontAwesomeIcon icon={faBoxesStacked} />} 
                    prodottoId={element.id} 
                    classButton={''} 
                    nomeProd={element.nome}
                    unitaMisura={element.infoUnitaMisura.nome}
                />
            </td>
        )
    }

    const viewAssegnaMg = (id , nome) => {
        setDatiAssegnaMagazzino(values => ({ ...values, ['prodottoId']: id , ['nomeProd'] : nome }))
        setViewAssegnaMagazzino(true)
    }

    const assegnaMg = async (stato) => {
        if (stato) {
            await prodotti_fetch.createAssPosMg({
                prodottoId : datiAssegnaMagazzino.prodottoId,
                codiceProd : datiAssegnaMagazzino.codiceProd,
                magazzinoId : datiAssegnaMagazzino.magazzinoId,
                livello1 : datiAssegnaMagazzino.livello1Res,
                livello2 : datiAssegnaMagazzino.livello2Res,
                livello3 : datiAssegnaMagazzino.livello3Res,
                livello4 : datiAssegnaMagazzino.livello4Res,
                livello5 : datiAssegnaMagazzino.livello5Res,
                livello6 : datiAssegnaMagazzino.livello6Res,
                stato : 1
    
            })
            .then(response => {
                setDatiAssegnaMagazzino({})
                setViewAssegnaMagazzino(false)
            })
            .catch(error=> {
                if (error?.response?.status === 406) {
                    navigate("/login");;
                }else {
                    setError(error?.response?.data)
                }
                //console.log(error?.response?.data , ' error');
            })
        } else {
            setViewAssegnaMagazzino(false)
        }
    }

    const aggiungiImgMod = async (file) =>{
        await caricaFile_fetch.modificaFoto({
            id : file.id ,
            prodId : datiModifica.id
        } )
        setImgProdMod(values => ( [...values,  file ]))
    }

    const aggiungiDocMod = async (file) =>{
       //console.log(file , ' file');
        
        await caricaFile_fetch.modificaDocumento({
            id : file.id ,
            prodottoId : datiModifica.id
        } )
        setImgProdMod(values => ( [...values,  file ]))
    }

    const impaginazione = async (impaginazione)=> {
        setPage(impaginazione.numeroPag)
        setPageSize(impaginazione.pageSize)
        if ( page !==impaginazione.numeroPag ||  pageSize !== impaginazione.pageSize) {
            await filtra({pageSize:impaginazione.pageSize , page : impaginazione.numeroPag , ...inputsFiltra })
            setAzzeraVar(0)
        }
    }

    const onCloseQt = async(stato) => {
        if (stato) {
            await prodotti_fetch.salvaInvetarioProd(qtPrimaImp)
            await readProdotti()
        }
        setQtPrimaImp(false)
        setQtPrimaImpError({})

    }

    const calQtIniziale = async () => {
        const {data} =await prodotti_fetch.calcolaQtIniziale(qtPrimaImp)
        console.log(data , ' data');
        
        setQtPrimaImp({...qtPrimaImp , ...data})
    }

   console.log(datiView , ' datiView');
   console.log(qtPrimaImp , ' tPrimaImp');
   
    
    //console.log(imgProd , ' imgProd' );
    return(
        <div className='p-2'>
            <PaginazioneTitoloPulsanteCrea titolo={'Anagrafica articoli'}  funCrea={() =>setViewCrea(true)} />

            <div className='m-4 ps-3 pt-4 pe-3' >
                <div className='border_filtra p-3 ms-4'style={{width : '98.3%'}} >
                    {/* <h3 className='text-primary' >Filtra</h3> */}
                    {/* <CampiProdotti 
                        value={inputs}
                        errors={{}}
                        onChange={handleChangeFiltra}
                        classiDiv='d-flex flex-wrap'
                    /> */}
                    <div className="p-2 d-flex flex-wrap">

                        <InputForm 
                            label='descrizione' 
                            type='text' 
                            placeholder='Inserisci descrizione'
                            name='descrizione'
                            value={!!inputs?.descrizione ? inputs.descrizione : ''}
                            onChange={(name , value) => handleChangeFiltra(name , value)}
                            classi=' w-25 m-2'
                            errors={{}}
                        />
                        <InputForm 
                            label='descrizione breve' 
                            type='text' 
                            placeholder='Inserisci descrizione breve'
                            name='descrizioneBreve'
                            value={!!inputs?.descrizioneBreve ? inputs.descrizioneBreve : ''}
                            onChange={(name , value) => handleChangeFiltra(name , value)}
                            classi=' w-25 m-2'
                            errors={{}}
                        />
                        <InputForm 
                            label='Codice a barre' 
                            type='text' 
                            placeholder='Inserisci Codice a barre'
                            name='codBarre'
                            value={!!inputs?.codBarre ? inputs.codBarre : ''}
                            onChange={(name , value) => handleChangeFiltra(name , value)}
                            classi=' w-25 m-2'
                            errors={{}}
                        />
                        <InputForm 
                            label='Codice produttore *' 
                            type='text' 
                            placeholder='Inserisci codice produttore'
                            name='codProd'
                            value={!!inputs.codProd ? inputs.codProd : ''}
                            onChange={(name , value) =>{ handleChangeFiltra(name , value)}}
                            classi='w-25 m-2'
                            errors={{}}
                        />
                        <InputForm 
                            label='Produttore' 
                            type='text' 
                            placeholder='Inserisci produttore'
                            name='produttore'
                            value={!!inputs.produttore ? inputs.produttore : ''}
                            onChange={(name , value) =>{ handleChangeFiltra(name , value)}}
                            classi='w-25 m-2'
                            errors={{}}
                        />
                        <InputForm 
                            label='Codice interno ' 
                            type='text' 
                            placeholder='Inserisci codice interno'
                            name='rifInterno'
                            value={!!inputs.rifInterno ? inputs.rifInterno : ''}
                            onChange={(name , value) => handleChangeFiltra(name , value)}
                            classi='w-25 m-2'
                            errors={{}}
                        />
                        <div className='col-6'>
                            <SwitchOr
                                label='Prima importazione'
                                number='primaImportazione'
                                stato={!!inputs.primaImportazione ? 1 : 0}
                                onChangeValue={(value , name) => handleChangeFiltra(name , value)}
                                classe=' ps-0 fw-bold ms-5'
                                width=' 16rem '
                            />
                        </div>
                    </div>
                    <div className='ps-3'>
                        <PulsantiFiltra
                            filtra={filtra}
                            azzera={readProdotti}
                        />
                    </div>
                </div>

                {/* <Tabella 
                    data={datiProd}
                    columns={columns}
                    Pulsanti={Pulsanti}
                /> */}

                <div className='p-3 pt-5 pe-4'>
                    <TabellaPaginazione
                        colonne={columns}
                        dati={datiProd}
                        totalePag={pageTot}
                        azzera={azzeraVar}
                        impaginazione={impaginazione}
                        fu={fu}
                        Pulsanti={Pulsanti}
                    />
                </div>


            </div>

                {viewCrea && <QuestionModal 
                    title = 'Crea articolo'
                    text = {
                    <>
                        <CampiProdotti 
                            value={datiCrea} 
                            onChange={handleChangeCrea} 
                            errors={error} 
                            classiDiv={'d-flex flex-wrap w-100'} 
                        />
                        <div style={{width : '69rem'}} className='ps-4'>
                            <UploadFile
                                txtInfo='Immagine articolo '
                                onSuccess={(file)=>setImgProd(values => ( [...values,  file ]))}
                                imgs={imgProd}
                            />
                        </div>

                        <ViewImgPreUpload
                            imgs={imgProd}
                            onChangeImg={(imgs)=> setImgProd(imgs)}
                            prodId={datiModifica.id}
                        />
                        <div style={{width : '69rem'}} className='ps-4'>
                            <UploadDocProd 
                                onSuccess={(file)=>setDocProd(values => ( [...values,  file ]))}
                            />
                        </div>
                        <ViewDocProd prodottoId={datiModifica.id} />
                    </>
                    }
                    YesLabel = 'Crea'
                    onClose = {creaProdotto}
                />}

                {viewModifica&& <QuestionModal 
                    title = 'Modifica articolo'
                    text = {
                    <>
                        <CampiProdotti 
                            value={datiModifica} 
                            onChange={handleChangeModifica} 
                            errors={error} 
                            classiDiv={'d-flex flex-wrap'} 
                            edit={true}
                        />
                        <div style={{width : '69rem'}} className='ps-4'>
                            <UploadFile
                                txtInfo='Immagine articolo'
                                onSuccess={(file)=>aggiungiImgMod(file)}
                                imgs={imgProdMod}
                            />
                        </div>
                        <ViewImgPreUpload
                            imgs={imgProdMod}
                            onChangeImg={(imgs)=> setImgProdMod(imgs)}
                            prodId={datiModifica.id}
                        />
                        <div style={{width : '69rem'}} className='ps-4'>
                            <UploadDocProd 
                                onSuccess={(file)=>aggiungiDocMod(file)}
                            />
                        </div>
                        <ViewDocProd prodottoId={datiModifica.id} />
                    </>
                    }
                    YesLabel = 'Salva'
                    onClose = {modificaProdotto}
                />}

                {viewView && <InfoModal
                  size='xl'
                  title={'Articolo : ' + datiView['Descrizione breve']}
                  handleClose={()=>setViewView(false)}
                  canClose='Chiudi'
                  text={
                    <div>
                       <div className="mb-5">
                            {Object.keys(datiView).map((item , key) => {
                                //console.log(item, ' itemc ', datiView[item]);
                                return(
                                    <span className='d-inline-flex flex-column m-3 flex-wrap col-2' key={key}>
                                        <span className='fw-bold' > {item} </span>
                                        <span className='pt-2 ' >{datiView[item] && datiView[item] }</span>
                                    </span>
                                )
                            })}
                       </div>
                        <div className='ps-3' >
                            <p className="col-2 fw-bold"> Immagini </p>
                            <ImgsProd prodId={viewView} />
                        </div>
                        <p className="ps-3 mt-5 mb-0 pb-0 col-2 fw-bold"> Documenti </p>
                        <ViewDocProd prodottoId={viewView} visualizza />
                        
                    </div>
                  }
                />}
                
                {viewAssegnaMagazzino && <QuestionModal 
                    title = {'Assegna magazzino a "'+ datiAssegnaMagazzino.nomeProd +'"'}
                    text = {
                        <div>
                            <AssegnaMg 
                                values={datiAssegnaMagazzino} 
                                onChange={handleChangeAssegnaPosizione}
                                errors={error}
                            />
                        </div>
                    }
                    YesLabel = 'Modifica'
                    onClose = {assegnaMg}
                />}

                {!!qtPrimaImp && <InventarioPrimaImp prodottoId={qtPrimaImp?.id}  nomeProd={qtPrimaImp?.nomeProd} onclose={oncloseInventario} mostra={inventarioView} />}
                
                {/* {qtPrimaImp && <QuestionModal 
                    title = {'Quantità prima importazione "'+ qtPrimaImp.nomeProd +'" , Magazzino centrale Ancona'}
                    text = {
                        <div className='d-flex'>
                            <div className='p-3' > 
                                <p className='fw-bold'>Quantità iniziale</p>
                                <p> {qtPrimaImp?.qtIniziale} </p>
                            </div>
                            <div className='p-3'>
                                <p className='fw-bold'>Quantità attuale</p>
                                <p> {qtPrimaImp?.qtAttuale} </p>
                            </div>
                            <div style={{ borderLeft: '1px solid #ccc', height: '5rem', margin: '0.5rem 2rem' }}></div>
                             <InputForm
                                label='Quantità rilevata'
                                name='qtAttualeRilevata'
                                value={qtPrimaImp?.qtAttualeRilevata}
                                onChange={(name , value) => setQtPrimaImp(values => ({ ...values, [name]: value }))}
                                classi='col-3 m-2'
                                errors={qtPrimaImpError}
                            />

                            <InputForm
                                label='Data e ora'
                                type={'date'}
                                name='dataCreate'
                                value={qtPrimaImp?.dataCreate}
                                onChange={(name , value) => setQtPrimaImp(values => ({ ...values, [name]: value }))}
                                classi='col-3 m-2'
                                errors={qtPrimaImpError}
                            />
                            <div className='p-3 pt-4' > 
                                <button className="btn btn-primary text-uppercase mt-5 ms-2" onClick={calQtIniziale}>
                                    calcola
                                </button>
                            </div>


                            <div style={{ borderLeft: '1px solid #ccc', height: '5rem', margin: '0.5rem 2rem' }}></div>
                            <div className='p-3' > 
                                <p className='fw-bold'>Nuova Quantità iniziale</p>
                                <p> {qtPrimaImp?.qtInizialeCalcolata || ''} </p>
                            </div>



                            {qtPrimaImpError?.message && <span className='text-danger ps-4' >{qtPrimaImpError.message}</span>}
                        </div>
                    }
                    YesLabel = 'Salva'
                    onClose = {onCloseQt}
                    classi=' modal-xxl '
                />} */}

                <ConfermaEliminazione nome={'Articolo '+viewEliminaProd.descrizioneBreve} stato={!!viewEliminaProd} conferma={eliminaProd} />
        </div>
    )
    
}